import {
  Box,
  Card,
  CardHeader,
  Typography,
  Grid,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@material-ui/core";

import { ExpandMore, Room } from "@mui/icons-material";

import MaskAndValid from "utils/maskAndValid";
import PhoneWithWhatsapp from "components/Texts/PhoneWithWhatsapp";
import EmailWithCopyAndSend from "components/Texts/EmailWithCopyAndSend";
import Tabs from "components/Tabs/Tabs";

const representativesLabels = ["Dados Básicos", "Contatos", "Endereços"];

const RepresentativeDataTabs = ({ data }) => {
  return (
    <Tabs
      tabsLabel={representativesLabels}
      tabsContent={[
        <Box key="basic-data" textAlign="left" component="span">
          <Typography variant="h4">
            Código ERP:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.CodERP : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            CNPJ:{" "}
            <Box component="span" fontWeight="300">
              {data ? MaskAndValid.maskCPNJCPF(data.CnpjCpfPessoa) : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Razão Social:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.RazaoSocial : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Nome Contato:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.NomeContato : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Marca:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.Marca : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            CC:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.CCLoja : ""}
            </Box>
          </Typography>
        </Box>,
        <Box key="contacts" textAlign="left" component="span">
          <Typography variant="h4">
            Telefone 1:{" "}
            <Box component="span" fontWeight="300">
              <PhoneWithWhatsapp phone={data?.Telefone1} />
            </Box>
          </Typography>
          <Typography variant="h4">
            Telefone 2:{" "}
            <Box component="span" fontWeight="300">
              <PhoneWithWhatsapp phone={data?.Telefone2} />
            </Box>
          </Typography>
          <Typography variant="h4">
            Email:{" "}
            <Box component="span" fontWeight="300">
              <EmailWithCopyAndSend email={data?.Email} />
            </Box>
          </Typography>
        </Box>,
        <Box key="addresses" textAlign="left" component="span">
          <Typography variant="h3" color="primary">
            Principal
          </Typography>
          <Typography variant="h4">
            Logradouro:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalRua : ""}
            </Box>
            {data &&
            Boolean(data.EndPrincipalRua) &&
            data.EndPrincipalRua.trim() > "" ? (
              <IconButton
                size="small"
                href={
                  "https://www.google.com/maps/place/" +
                  MaskAndValid.formattAddressGoogleMaps(
                    data.EndPrincipalRua,
                    data.EndPrincipalNumero,
                    data.EndPrincipalBairro,
                    data.EndPrincipalCidade,
                    data.EndPrincipalUf,
                    data.EndPrincipalCep
                  )
                }
                target="_blank"
              >
                <Room
                  fontSize="large"
                  style={{ marginLeft: 5, marginBottom: 1 }}
                ></Room>
              </IconButton>
            ) : (
              ""
            )}
          </Typography>
          <Typography variant="h4">
            Número:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalNumero : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Bairro:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalBairro : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Cidade:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalCidade : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Uf:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalUf : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            CEP:{" "}
            <Box component="span" fontWeight="300">
              {data ? MaskAndValid.maskCEP(data.EndPrincipalCep) : ""}
            </Box>
          </Typography>
          <Typography variant="h4">
            Complemento:{" "}
            <Box component="span" fontWeight="300">
              {data ? data.EndPrincipalComplemento : ""}
            </Box>
          </Typography>
        </Box>,
      ]}
    />
  );
};

export default function CardRepresentante({ representatives, isMobile }) {
  return (
    <Grid item xs={isMobile ? 12 : 6}>
      <Card>
        <CardHeader
          title="Representantes"
          titleTypographyProps={{
            component: Typography,
            variant: "h2",
          }}
        />
        {representatives &&
          representatives?.map((data, index) => (
            <div key={index}>
              <Accordion defaultExpanded={index === 0}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>{data.RazaoSocial}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <RepresentativeDataTabs data={data} />
                </AccordionDetails>
              </Accordion>
            </div>
          ))}
      </Card>
    </Grid>
  );
}
